import { Component, Input } from "@angular/core";

@Component( {
    selector: 'load-spinner',
    template: `<div class="load-spinner" [ngClass]="{'inner': inner}" *ngIf="show"> <div class="spinner"> </div> </div>`,
    styleUrls: ['./load-spinner.component.scss']
})
export class LoadSpinner {
    @Input() public show:boolean;
    @Input() public inner:boolean;
}